<script setup>
import DateRangeFilter from '@/components/Form/DateRangeFilter.vue';
import { modelDateValue, timestampToDayMonthString, timestampToTime } from '@/helpers';
import { useAuthStore } from '@/stores/auth';
import { storeToRefs } from 'pinia';
import { computed, onMounted, ref, watch } from 'vue';
import { useRoute } from 'vue-router';
import { useResponseMessageStore } from "@/stores/response_message";
import { useI18n } from "vue-i18n";
import { toFixedTwo } from '@/helpers';

const auth = useAuthStore()
const responseMessageStore = useResponseMessageStore()
const { getUser } = storeToRefs(auth)
const { t } = useI18n()
const filters = ref({
    sd: modelDateValue(),
    ed: modelDateValue()
})
const transactions = ref([])
const route = useRoute()

const applyFilters = async (dates) => {
    filters.value = { ...dates }
    await search()
}

const search = async () => {
    await auth.fetchTransactions({
        currency: route.params.id,
        ...filters.value
    }).then(res => {
        if (res.data.ok) {
            transactions.value = res.data.data
        }
    })
}

watch(() => route.params.id, async (value) => {
    await search()
})

onMounted(async () => {
    await search()
})
const showWarning =( )=>{
    responseMessageStore.setMessage(t('transactions.warning_message'))
}

const totalWithdraw = computed(() =>
  transactions.value
    .filter(trx => trx.st == 1 && trx.receiver._id !== getUser.value._id)
    .reduce((sum, trx) => sum + trx.am, 0)
)

const totalDeposit = computed(() =>
  transactions.value
    .filter(trx => trx.st == 1 && trx.receiver._id == getUser.value._id)
    .reduce((sum, trx) => sum + trx.am, 0)
)

</script>

<template>
    <div>
        <DateRangeFilter @apply="applyFilters" />

        <div class="mt-4 px-4 space-y-4">
            <div class="trx-Container overflow-x-auto">
                <table class="trx-Table w-full  min-w-max">
                    <thead>
                        <tr>
                            <th class="left">{{$t('app.15')}}</th>
                            <th class="text-center">{{ $t('general.3') }}</th>
                            <th>{{$t('app.18')}}</th>
                            <th>{{$t('app.31')}}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr 
                            v-for="trx in transactions"
                            :class="trx.st == 2 || trx.st == 3
                                ? 'text-orange-500'
                                : (trx.receiver._id == getUser._id ? 'receive' : 'send')"
                        >
                            <td class="left whitespace-nowrap">{{ timestampToDayMonthString(trx.createdAt) }} {{ timestampToTime(trx.createdAt) }}</td>
                            <td class="text-center  whitespace-nowrap">{{ trx.sender.un }} -> {{ trx.receiver.un }}</td>
                            <td>{{ trx.am }} {{ trx.currency.cod }}</td>
                            <td class="flex items-center justify-end gap-2">
                                <span v-if="trx.st == 2" @click="showWarning">
                                    <img src="/warning.svg" class="w-5 h-5 text-orange-500 cursor-pointer"/>
                                </span>
                                <span>{{ $t(`transactions.status.${trx.st}`)}}</span>
                            </td>
                        </tr>
                    </tbody>
                    <tfoot v-if="transactions?.length > 0">
                        <tr>
                            <th class="left" colspan="2">{{ $t('transactions.total_withdraw') }}</th>
                            <th>{{ toFixedTwo(totalWithdraw) }} {{ transactions[0].currency.cod }}</th>
                        </tr>
                        <tr>
                            <th class="left" colspan="2">{{ $t('transactions.total_deposit') }}</th>
                            <th>{{ toFixedTwo(totalDeposit) }} {{ transactions[0].currency.cod }}</th>
                        </tr>
                    </tfoot>
                </table>
            </div>
        </div>
    </div>
</template>

<style scoped>
.trx-Container {
    background-image: var(--mgc-bg);
    @apply rounded-md ;
}

.trx-Table {
    @apply w-full divide-y divide-neutral-500/30  table-auto;
    font-size: 14px;       
    line-height: 20px;
    text-align: right;
}
@media (max-width: 640px) {
  .trx-Table {
    font-size: 2.5vw;
    line-height: 7vw;
  }
}
.trx-Table th, 
.trx-Table td {
    @apply px-2
}

.trx-Table th {
    @apply font-normal text-neutral-400;
}

.trx-Table tr.receive {
    @apply text-emerald-400;
}
.trx-Table tr.send {
    @apply text-red-400;
}

.trx-Table .left {
    @apply text-left;
}

.trans-status-2{
    @apply text-orange-500
}

</style>